<template>
  <div id="userManager">
    <div class="allSearch">
      <div style="align-items: flex-end" class="newSearch d_flex">
        <div style="white-space: normal;width: auto;">
          <p>
            <!-- <span>姓名</span>-->
            <!-- <input @keyup.enter="getList(1)" class="allInput" type="text" placeholder="姓名" v-model="postData.name"> -->
            <input @keyup.enter="getList(1)" class="allInput" type="text" placeholder="医生姓名" v-model="postData.name">
          </p>
          <!--          <p v-if="onSearch">-->
          <!--            <span>性别</span>-->
          <!--            <select class="allSelect" v-model="postData.gender">-->
          <!--              <option value="-1">未知</option>-->
          <!--              <option value="0">男</option>-->
          <!--              <option value="1">女</option>-->
          <!--              <option value="2">全部</option>-->
          <!--            </select>-->
          <!--          </p>-->
          <p>
            <!-- <span>工作邮箱</span>-->
            <!-- <input @keyup.enter="getList(1)" class="allInput" type="text" placeholder="工作邮箱" v-model="postData.email"> -->
            <input @keyup.enter="getList(1)" class="allInput" type="text" placeholder="医院" v-model="postData.hospital">
          </p>
          <p>
            <!-- <span>分公司</span>-->
            <allSelect :chooseData="departList" :needSearch="true" :needReturn="'nameId'" :placeholder="''" :matchValue="'description'" :showValue="'{{description}}'" v-model="postData.dept">
            </allSelect>
          </p>
          <p>
            <!-- <span>所在地</span>-->
            <input @keyup.enter="getList(1)" class="allInput" type="text" v-model="postData.title" placeholder="学术职称">
          </p>
          <p>
            <!-- <span>地址</span>-->
            <input @keyup.enter="getList(1)" class="allInput" type="text" v-model="postData.ProfTitle" placeholder="职务">
          </p>
          <!-- <p> -->
            <!-- <allSelect :chooseData="allIsKol" :needReturn="'selIsAttention'" :placeholder="'是否KOL'" :matchValue="'IsAttentionName'" :showValue="'{{IsAttentionName}}'" v-model="postData.IsKOL">
            </allSelect> -->
            <!-- <span>部门</span>-->
            <!-- <input @keyup.enter="getList(1)" class="allInput" type="text" v-model="postData.org_Acronym" placeholder="部门"> -->
          <!-- </p> -->
          <p>
            <allSelect :chooseData="allIsInvert" :needReturn="'selIsAttention'" :placeholder="'是否认证'" :matchValue="'IsAttentionName'" :showValue="'{{IsAttentionName}}'" v-model="postData.isRz">
            </allSelect>
          </p>
            <!--          <p  v-if="onSearch">-->
            <!--            <span>已关注</span>-->
            <!--            <select  class="allSelect" v-model="postData.IsAttention">-->
            <!--              <option :value="true" >是</option>-->
            <!--              <option :value="false" >否</option>-->
            <!--            </select>-->
            <!--          </p>-->
          <p>
            <!-- <span>已关注</span>-->
            <abbr class="d_i">
              <allSelect :chooseData="allIsAttention" :needReturn="'selIsAttention'" :placeholder="''" :matchValue="'IsAttentionName'" :showValue="'{{IsAttentionName}}'" v-model="postData.isFollewd">
              </allSelect>
            </abbr>
          </p>
          <p>
            <cander v-model="postData.beginSubTime" :className="'allInput'" placeholderName="关注时间 - 开始"  class="d_i" style="vertical-align: middle"></cander>
          </p>
          <p>
            <cander v-model="postData.endSubTime" :minDate="postData.beginSubTime" :className="'allInput'" placeholderName="关注时间 - 结束"  class="d_i" style="vertical-align: middle"></cander>
          </p>
          <p>
            <cander v-model="postData.beginRegTime" :className="'allInput'" placeholderName="注册时间 - 开始"  class="d_i" style="vertical-align: middle"></cander>
          </p>
          <p>
            <cander v-model="postData.endRegTime" :minDate="postData.beginRegTime" :className="'allInput'" placeholderName="注册时间 - 结束"  class="d_i" style="vertical-align: middle"></cander>
          </p>
          <p>
            <allSelect :chooseData="fieldsList" :multiple="true" v-on:on-change="changeField" :needReturn="'id'" :placeholder="'请选择领域'" :matchValue="'name'" :showValue="'{{name}}'" v-model="postData.fieldIds">
            </allSelect>
          </p>
          <p>
            <allSelect :chooseData="indicationsList" :multiple="true" :needReturn="'id'" :placeholder="'请选择适应症'" :matchValue="'name'" :showValue="'{{name}}'" v-model="postData.indicationIds">
            </allSelect>
          </p>
        </div>
        <div style="width: auto">
          <!-- <span class="colorCH c_p" style="text-decoration: underline" @click="tewoSearch()">{{onSearch ? '快速搜索':'高级搜索'}}</span>-->
          <button class="redButton" @click="getList(1)">
            搜索
          </button>
          <!-- <button @click="clearPostData" class="cancelButtonTwo">
            清空
          </button> -->
        </div>
      </div>
    </div>
    <div class="allTablePlace">
      <div>
        <nav v-if="$childMenu.indexOf('导出') >= 0" class="m_b_10"><button class="redButtonTwo" @click="exportList()">导出</button></nav>
        <div style="overflow:auto; width: 100%;">
          <table cellspacing="0" class="allTable" :style="myList.length > 0 ? 'width: 170%;' : 'width: 100%;'">
            <thead>
            <tr>
              <th>操作</th>
              <th>用户来源</th>
              <th>医生姓名</th>
              <th>医院</th>
              <!-- <th>姓名</th> -->
              <th>科室</th>
              <th>省份</th>
              <th>城市</th>
              <th>是否认证</th>
              <th>是否关注</th>
              <th>关注时间</th>
              <th>注册时间</th>
              <th>领域</th>
              <th>适应症</th>

              <th>学术职称</th>
              <th>职务</th>
              <!-- <th>是否KOL</th> -->
              <th>K级医生</th>
              <!-- <th>K级医生理由</th> -->
              <!-- <th>工作邮箱</th> -->
              <!-- <th>分公司</th> -->
              <!-- <th>所在地</th> -->
              <!-- <th>地址</th> -->
              <!-- <th>部门</th> -->
              <!-- <th class="t_c">已关注</th> -->

            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in myList" :key="index">
              <td width="10%" style="min-width:100px;max-width:210px;" >
                <!-- <div class="icon more iconfont icongengduo moreOperations">
                  <ul>
                    <li @click="viewUserList(item)">查看</li>
                    <li v-if="$childMenu.indexOf('注销') >= 0" @click="delHcp(item.openId)">解绑</li>
                  </ul>
                </div> -->
                <button @click="viewUserList(item)" class="cancelButtonTwo m_r_10" style="padding:4px 20px">查看</button>
                <button @click="delHcp(item.openId)"  v-if="$childMenu.indexOf('注销') >= 0" class="redButtonTwo" style="padding:4px 20px">解绑</button>
              </td>
              <td width="10%" class="NoWrap" style="max-width: 80px" :title="returnHCPType(item.hcpType)">{{returnHCPType(item.hcpType)}}</td>
              <td width="10%" class="NoWrap" style="max-width: 80px" :title="item.docName">{{item.cdwD_DOCName ? item.cdwD_DOCName : item.docName}}</td>
              <td width="10%" class="NoWrap" style="max-width: 250px;" :title="item.instName">{{item.cdwD_InstName ? item.cdwD_InstName : item.instName}}</td>
              <td width="10%" class="NoWrap" style="max-width: 100px;"  :title="item.department">{{item.cdwD_Department ? item.cdwD_Department : item.department}}</td>
              <td width="5%" class="NoWrap" style="max-width: 50px;"  :title="item.province">{{item.cdwD_Province ? item.cdwD_Province :item.province}}</td>
              <td width="5%" class="NoWrap" style="max-width: 100px;" :title="item.city">{{item.cdwD_City ? item.cdwD_City :item.city}}</td>

              <td width="5%" class="NoWrap" style="max-width: 50px;" :title="item.hcpType === 'Import' || item.hcpType === 'RealTimeSync' || item.hcpType === 'eContract' ? '已认证' : '未认证'">
                {{item.hcpType === 'Import' || item.hcpType === 'RealTimeSync' || item.hcpType === 'eContract' ? '已认证' : '未认证'}}
              </td>
              <td width="5%" class="NoWrap" style="max-width: 50px;" :title="item.isFollowed ? '是' : '否'">{{item.isFollowed ? '是' : '否'}}</td>
              <td width="10%" class="NoWrap" style="max-width: 150px;">{{item.subTime ? $commonJs.returnNewDate(item.subTime) : ''}}</td>
              <td width="10%" class="NoWrap" style="max-width: 150px;">{{item.regTime ? $commonJs.returnNewDate(item.regTime) : ''}}</td>
              <td width="25%" class="NoWrap" style="min-width:200px;max-width:230px;" :title="returnStr(item.fields)">{{returnStr(item.fields)}}</td>
              <td width="25%" class="NoWrap" style="min-width:200px;max-width:230px;" :title="returnStr(item.indicationInfos)">{{returnStr(item.indicationInfos)}}</td>


              <td width="10%" class="NoWrap" style="max-width: 100px;" :title="item.title">{{item.title}}</td>
              <td width="10%" class="NoWrap" style="max-width: 100px;" :title="item.profTitle">{{item.profTitle}}</td>
              <!-- <td width="5%" class="NoWrap" style="max-width: 50px;" :title="item.isKOL ? '是' : '否'">{{item.isKOL ? '是' : '否'}}</td> -->
              <td width="10%" class="NoWrap" style="max-width: 100px;" :title="item.k_SEGMENT">{{item.k_SEGMENT}}</td>
              <!-- <td width="10%" class="NoWrap" style="max-width: 100px;" :title="item.k_Medical_Reason">{{item.k_Medical_Reason}}</td> -->


            </tr>
            </tbody>
          </table>
        </div>

      </div>
      <page v-if="totalPage !== 0" :totalCount="totalCount" v-on:on-getList="getList($event)" :totalPage="totalPage" :page="page" :explain="0"></page>
    </div>

    <model v-if="showModel" :buttonType="2" :title="'用户管理'" :minWidth="'800px'" v-on:on-cancel="cancelModel()" v-on:on-confirm="confirModel()">
      <!-- <div class="modelInput"><span>账号名称</span><span><input class="allInput" type="text"></span></div>-->
      <div id="modelSwitah" class="m_10">
        <div class="d_i font16 f_w">
          <input v-model="tabSwitch" :value="1" type="radio" class="allTabRadio" name="swithTab" id="modelSwitah1">
          <label for="modelSwitah1">用户信息</label>
        </div>
        <div class="d_i  font16 m_l_10 f_w">
          <input v-model="tabSwitch"  :value="2" type="radio" class="allTabRadio" name="swithTab" id="modelSwitah2">
          <label for="modelSwitah2">应用列表</label>
        </div>
        <div class="p_r">
          <div :class="tabSwitch === 1 ? 'tabShowPage p_r' : 'tabNoShow p_a'" class="modelHeight">
            <dl class="userInformation">
              <dd><span>姓名：</span><abbr>{{userDetails.name}}</abbr></dd>
              <dd><span>性别：</span><abbr>{{$commonJs.getGender(userDetails.gender)}}</abbr></dd>
              <dd><span>工作邮箱：</span><abbr>{{userDetails.email}}</abbr></dd>
              <dd><span>分公司：</span><abbr>{{userDetails.company_Name}}</abbr></dd>
              <dd><span>所在地：</span><abbr>{{userDetails.location}}</abbr></dd>
              <dd><span>地址：</span><abbr>{{userDetails.building_Long}}</abbr></dd>
              <dd><span>部门：</span><abbr>{{userDetails.org_Acronym}}</abbr></dd>
              <dd><span>职位：</span><abbr>{{userDetails.title}}</abbr></dd>
              <dd><span>企业微信ID:</span><abbr>{{userDetails.openId}}</abbr></dd>
              <dd><span>申请时间：</span><abbr>{{userDetails.applyTime}}</abbr></dd>
              <!--<dt><span>Device ID:</span><abbr><b style="margin-right: 5px;" v-for="(item, index) in userDetails.deviceIdList" :key="index" >{{item}}</b></abbr></dt>-->
              <dd><span>注册时间：</span><abbr>{{$commonJs.returnNewDate(userDetails.registerTime)}}</abbr></dd>
              <dd><span>已关注：</span><abbr>{{userDetails.isAttention ? '是' : '否'}}</abbr></dd>
            </dl>
          </div>
          <div :class="tabSwitch === 2 ? 'tabShowPage p_r' : 'tabNoShow p_a'"  class="modelHeight" style="max-height: 323px;overflow: auto">
            <table cellspacing="0" class="allTable alltableHui">
              <thead>
              <tr style="background-color: #FBFBFB;color: #797979">
                <th>应用图标</th>
                <th>应用ID</th>
                <th>应用名称</th>
                <th>是否启用</th>
              </tr>
              </thead>
              <tbody v-if="appList.length > 0">
              <tr :key="index" v-for="(item, index) in appList">
                <td><img :src="item.square_Logo_Url" width="45px" height="45px" alt=""></td>
                <td>{{item.agentId}}</td>
                <td>{{item.name}}</td>
                <td>{{item.close === 0 ? '启动': '禁用'}}</td>
              </tr>
              </tbody>
              <tbody v-else>
              <tr class="t_c">
                <td colspan="4" class="colorZh" style="font-size: 14px!important;">暂无数据</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td> </td>
                <td> </td>
                <td> </td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td> </td>
                <td> </td>
                <td> </td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td> </td>
                <td> </td>
                <td> </td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td> </td>
                <td> </td>
                <td> </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </model>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'userManager',
  data () {
    return {
      allIsAttention: [
        {
          selIsAttention: '',
          IsAttentionName: '是否关注'
        },
        {
          selIsAttention: true,
          IsAttentionName: '已关注'
        },
        {
          selIsAttention: false,
          IsAttentionName: '未关注'
        }
      ],
      allIsKol: [
        {
          selIsAttention: '',
          IsAttentionName: '是否Kol'
        },
        {
          selIsAttention: true,
          IsAttentionName: '是'
        },
        {
          selIsAttention: false,
          IsAttentionName: '否'
        }
      ],
      allIsInvert: [
        {
          selIsAttention: '',
          IsAttentionName: '是否认证'
        },
        {
          selIsAttention: true,
          IsAttentionName: '已认证'
        },
        {
          selIsAttention: false,
          IsAttentionName: '未认证'
        }
      ],
      allgender: [
        {
          id: -1,
          name: '未知'
        },
        {
          id: 0,
          name: '男'
        },
        {
          id: 1,
          name: '女'
        },
        {
          id: 2,
          name: '性别'
        }
      ],
      onSearch: false,
      showModel: false,
      tabSwitch: 1,
      totalPage: 1,
      totalCount: 0,
      departList: [{
        nameId: '',
        description: '选择科室'
      }],
      page: 1,
      postData: {
        dept: '',
        PageIndex: 1,
        PageSize: this.$commonJs.commonPageSize,
        name: '',
        email: '',
        ProfTitle: '',
        IsKOL: '',
        isRz: '',
        isFollewd: '',
        company_Name: '',
        location: '',
        building_Long: '',
        org_Acronym: '',
        IsAttention: '1',
        beginSubTime: '',
        endSubTime: '',
        beginRegTime: '',
        endRegTime: '',
        fieldIds: '',
        indicationIds: ''
      },
      myList: [],
      userDetails: {},
      appList: [],
      appowner: JSON.parse(window.sessionStorage.getItem('nowApp')),
      showOther: false,
      fieldsList: [],
      indicationsList: [],
      isAdmin: JSON.parse(window.localStorage.getItem('isAdmin'))
    }
  },
  created () {
    console.log(this.isAdmin, 'isAdmin')
    if (this.appowner) {
      if (this.appowner.roles.indexOf('AppOwner') >= 0) {
        this.showOther = true
      }
    }
    this.getList(1)
    this.getDepart()
    // 获取领域
    this.getFieldsList()
    // 获取适应症
    this.getIndicationsList()
  },
  methods: {
    exportList () {
      let that = this
      let url = ''
      let name = ''
      var xmlResquest = new XMLHttpRequest()
      const data = JSON.parse(JSON.stringify(this.postData))
      data.endSubTime = data.endSubTime ? encodeURIComponent(data.endSubTime + ' 23:59:59') : ''
      data.endRegTime = data.endRegTime ? encodeURIComponent(data.endRegTime + ' 23:59:59') : ''
      delete data.fieldIds
      delete data.indicationIds
      url = this.$commonJs.returnQuery(process.env.config.baseUrl + '/api/hcp/export', data)
      let params = {
        fieldIds: this.postData.fieldIds ? (this.postData.fieldIds.split(',')).map(item => Number(item)) : [],
        indicationIds: this.postData.indicationIds ? (this.postData.indicationIds.split(',')).map(item => Number(item)) : []
      }
      axios.post(url, params, {responseType: "arraybuffer"}).then(res => {
        console.log(res, 'exportList')
        const data = res.data
        const url = window.URL.createObjectURL(new Blob([data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}))
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', 'hcp列表.xlsx')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      }).catch(err => {
        console.log(err, 'err')
      })

      // name = 'hcp列表'
      // xmlResquest.open('GET', url, true)
      // xmlResquest.setRequestHeader('Content-type', 'application/json')
      // xmlResquest.setRequestHeader('Authorization', 'Bearer ' + window.localStorage.getItem('TaToken'))
      // xmlResquest.responseType = 'blob'
      // xmlResquest.onload = function (oEvent) {
      //   var content = xmlResquest.response
      //   var elink = document.createElement('a')
      //   elink.download = name + '.xlsx'
      //   elink.style.display = 'none'
      //   var blob = new Blob([content])
      //   if (that.$IENum === 11) {
      //     window.navigator.msSaveOrOpenBlob(blob, name + '.xlsx')
      //   } else {
      //     elink.href = URL.createObjectURL(blob)
      //     document.body.appendChild(elink)
      //     elink.click()
      //     document.body.removeChild(elink)
      //   }
      // }
      // xmlResquest.send()
    },
    getDepart (callback) {
      this.$axiox.get('/api/Dict/GetHosDepts').then(p => {
        for (let i = 0; i < p.length; i++) {
          p[i].nameId = p[i].description
        }
        this.departList = this.departList.concat(p)
        if (callback) {
          callback()
        }
      })
    },
    clearPostData () {
      this.postData.gender = 2
      this.postData.name = ''
      this.postData.email = ''
      this.postData.company_Name = ''
      this.postData.location = ''
      this.postData.building_Long = ''
      this.postData.org_Acronym = ''
      this.postData.IsAttention = '1'
    },
    // 切换搜索条件
    tewoSearch () {
      this.onSearch = !this.onSearch
    },
    getList (pageIndex) {
      this.postData.PageIndex = pageIndex
      let data = JSON.parse(JSON.stringify(this.postData))
      delete data.fieldIds
      delete data.indicationIds
      data.endSubTime = data.endSubTime ? encodeURIComponent(data.endSubTime + ' 23:59:59') : ''
      data.endRegTime = data.endRegTime ? encodeURIComponent(data.endRegTime + ' 23:59:59') : ''
      if (data.IsKOL === '') {
        delete data['IsKOL']
      }
      if (data.isRz === '') {
        delete data['isRz']
      }
      if (data.isFollewd === '') {
        delete data['isFollewd']
      }
      console.log(data, 'data')
      console.log(this.postData, 'this.postData')
      let url
      url = this.$commonJs.returnQuery('/api/hcp/query', data)
      let params = {
        fieldIds: this.postData.fieldIds ? (this.postData.fieldIds.split(',')).map(item => Number(item)) : [],
        indicationIds: this.postData.indicationIds ? (this.postData.indicationIds.split(',')).map(item => Number(item)) : []
      }
      this.$axiox.post(url, params).then(msg => {
        console.log(msg, 'msg')
        this.myList = msg.data
        this.page = pageIndex
        this.totalPage = Math.ceil(msg.total / this.postData.PageSize)
        this.totalCount = msg.total
      })
    },
    // 查看用户信息
    viewUserList (item) {
      // this.tabSwitch = 1
      // this.showModel = true
      // this.userDetails = object
      // this.$axiox.get('/api/user/' + object.id + '/apps').then(msg => {
      //   this.appList = msg.result
      // })
      this.$router.push({
        name: 'userDetail',
        query: {
          id: item.id
        }
      })
    },
    confirModel () {
    },
    cancelModel () {
      this.showModel = false
    },
    returnStr(arr) {
      let str = ''
      if (arr && arr.length > 0) {
        let newArr = arr.map(item => item.name)
        str = newArr.join(',')
      }
      return str
    },
    // 获取领域
    getFieldsList () {
      this.$axiox.get(`/api/Dict/GetFields`).then(res => {
        console.log(res, 'getFieldsList')
        this.fieldsList = res
        // [
        //   {
        //     id: 0,
        //     name: '全部',
        //   },
        //   ...res
        // ]
      })
    },
    // 获取适应症
    getIndicationsList (ids = []) {
      let params = ids
      this.$axiox.post(`/api/Dict/GetIndications`, params).then(res => {
        console.log(res, 'getIndicationsList')
        this.indicationsList = res
        // [
        //   {
        //     id: 0,
        //     fieldId: '',
        //     name: '全部',
        //   },
        //   ...res
        // ]
      })
    },
    changeField () {
      this.postData.indicationIds = ''
      console.log(this.postData.fieldIds, 'this.postData.fieldIds')
      if (this.postData.fieldIds) {
        let fieldIds = (this.postData.fieldIds.split(',')).map(item => Number(item))
        this.getIndicationsList(fieldIds)
      } else {
        this.getIndicationsList()
      }
    },
    delHcp (openId) {
      this.$commonJs.doubleComfirm({
        content: '您是否确认解绑？',
        successFun: () => {
          this.$axiox.del(`/api/hcp/DelHcpCustomer?openId=${openId}&channel=P&fromWechat=false`).then(res => {
            console.log(res, 'delHcp')
            if (res == 'True') {
              this.$commonJs.alertTips({
                type: 'success',
                title: '成功',
                content: '您已解绑成功',
                stayTime: 5
              })
              // 获取HCP列表
              this.getList(1)
            }
          })
        },
        errorFun: err => {
        }
      })
    },
    returnHCPType(type) {
      let str = ''
      if (type === 'Import') {
        // str = 'CDW'
        str = 'OCE'
      } else if (type === 'Register') {
        str = '注册'
      } else if (type === 'RealTimeSync') {
        str = 'OCE'
      } else if (type === 'eContract') {
        str = 'eContract'
      } else if (type === '5') {
        str = '武家会议'
      } else if (type === '武家会议') {
        str = '武家会议'
      }else if (type === '医脉通') {
        str = '医脉通'
      }
      return str
    }
  }
}
</script>

<style scoped>
  #modelSwitah{
    padding:0 10px;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/userManager/userList.vue